import React from 'react';
import { PlusCircleOutlined } from '@ant-design/icons';
import { Button } from '@app/components/common/buttons/Button/Button';
import { useTranslation } from 'react-i18next';

export const CreateIssue: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = (props) => {
  const { t } = useTranslation();
  const currentPath = window.location.pathname.split('/')[1];
  const buttonText = currentPath === 'fac' ? t('fac.header.createItem') : currentPath === 'kaizen' ? 'Tạo mới' : t('issuepage.createissue');
  return (
    <Button
      icon={<PlusCircleOutlined />}
      {...props}
      type="primary"
      htmlType="submit"
    >
      {buttonText}
    </Button>
  );
};


// const Button = styled(BaseButton)<{ $isDark: boolean }>`
//   color: ${(props) => BASE_COLORS[props.$isDark ? 'white' : 'black']};
//   background: ${(props) => BASE_COLORS[props.$isDark ? 'green' : 'green']};
//   border-radius: 50px;
//   padding-top: 0;
//   padding-bottom: 0;
//   display: flex;
//   align-items: center;

//   &:hover,
//   &:active,
//   &:focus {
//     color: ${(props) => BASE_COLORS[props.$isDark ? 'black' : 'black']};
//     background: ${(props) => BASE_COLORS[props.$isDark ? 'white' : 'white']};
//   }
// `;

// const GithubIcon = styled(FormOutlined)`
//   font-size: 1.5rem;
//   vertical-align: middle;
// `;
